<template>
  <div class="projects-page">
    <!-- Filters: always visible so user sees structure immediately -->
    <b-card class="p-0 filter-card rounded-lg">
      <b-row>
        <b-col
          cols="12"
          class="d-flex align-items-center justify-content-between m-0"
        >
          <h3 class="ml-1 ">
            الفلاتر
          </h3>
          <b-button
            variant="outline-secondary"
            size="sm"
            @click="clearAllFilters"
          >
            <feather-icon
              icon="XCircleIcon"
              size="14"
              class="mr-50"
            />
            مسح الفلاتر
          </b-button>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-form-input
            v-model="filter.search"
            placeholder="بحث"
          />
        </b-col>
        <b-col
          v-if="status_data"
          cols="12"
          md="3"
        >
          <v-select
            v-model="filter.status"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="status_data"
            class="w-100 mb-0"
            :reduce="(val) => val"
            placeholder="Status"
            :label="$i18n.locale == 'en' ? 'name' : 'name_local'"
          >
            <template v-slot:option="option">
              {{ $i18n.locale == "ar" ? option.name_local : option.name }}
            </template>
            <template #selected-option="{ name, name_local }">
              <div style="display: flex; align-items: baseline">
                <strong v-if="$i18n.locale == 'ar'">{{ name_local }} </strong>
                <strong v-else>{{ name }} </strong>
              </div>
            </template>
            <template #no-options>
              {{ $t("noMatching") }}
            </template>
          </v-select>
        </b-col>
        <b-col
          v-if="serviceTypes && hasRole('admin')"
          cols="12"
          md="3"
        >
          <v-select
            v-model="filter.service_type_id"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="serviceTypes"
            class="w-100 mb-0"
            :reduce="(val) => val.id"
            placeholder="نوع الخدمة"
          >
            <template v-slot:option="option">
              {{ $i18n.locale == "ar" ? option.name_ar : option.name }}
            </template>
            <template #selected-option="{ name_ar }">
              <div style="display: flex; align-items: baseline">
                <strong v-if="$i18n.locale == 'ar'">{{ name_ar }} </strong>
                <strong v-else>{{ name_ar }} </strong>
              </div>
            </template>
            <template #no-options>
              {{ $t("noMatching") }}
            </template>
          </v-select>
        </b-col>

        <!-- Execution status -->
        <!-- <b-col cols="12" md="3" >
                  <b-form-select
                    v-model="filter.current_execution_status"
                    :options="executionStatusOptions"
                  />
                </b-col> -->

        <!-- Custom Task filters -->
        <b-col
          cols="12"
          md="3"
        >
          <v-select
            v-model="filter.custom_task_id"
            :options="customTaskOptions"
            :reduce="val => val.id"
            :get-option-label="option => option.name"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            class="w-100 mb-0"
            placeholder="المهمة المخصصة"
            :clearable="true"
            :loading="loadingCustomTasks"
          >
            <template v-slot:option="option">
              {{ option.name }}
            </template>
            <template #selected-option="{ name }">
              <div style="display: flex; align-items: baseline">
                <strong>{{ name }}</strong>
              </div>
            </template>
            <template #no-options>
              {{ $t("noMatching") }}
            </template>
          </v-select>
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-form-select
            v-model="filter.custom_task_status"
            :options="customTaskStatusOptions"
            placeholder="حالة المهمة المخصصة"
          />
        </b-col>

        <!-- Owner filters -->
        <!-- <b-col cols="12">
                  <h5 class="ml-1">بيانات المالك</h5>
                </b-col> -->
        <b-col
          cols="12"
          md="3"
        >
          <b-form-input
            v-model="filter.owner_name"
            placeholder="اسم المالك"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-form-input
            v-model="filter.owner_national_id"
            placeholder="رقم قومي"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
        >
          <b-form-input
            v-model="filter.owner_phone"
            placeholder="هاتف"
          />
        </b-col>

        <!-- Location filters -->
        <!-- <b-col cols="12">
                  <h5 class="ml-1">الموقع</h5>
                </b-col> -->
        <b-col
          cols="12"
          md="3"
          class="location-filter"
        >
          <v-select
            v-model="filter.governorate_id"
            :options="governorates.data"
            :reduce="val => val.id"
            :get-option-label="option => option.name_ar || option.name || option.name_local"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            class="w-100 mb-0"
            placeholder="المحافظة"
            :clearable="true"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="location-filter"
        >
          <v-select
            v-model="filter.center_id"
            :options="centers.data"
            :reduce="val => val.id"
            :get-option-label="option => option.name_ar || option.name || option.name_local"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            class="w-100 mb-0"
            placeholder="المركز"
            :clearable="true"
            :disabled="!filter.governorate_id"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="location-filter"
        >
          <v-select
            v-model="filter.city_id"
            :options="cities.data"
            :reduce="val => val.id"
            :get-option-label="option => option.name_ar || option.name || option.name_local"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            class="w-100 mb-0"
            placeholder="المدينة"
            :clearable="true"
            :disabled="!filter.center_id"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="location-filter"
        >
          <v-select
            v-model="filter.village_id"
            :options="villages.data"
            :reduce="val => val.id"
            :get-option-label="option => option.name_ar || option.name || option.name_local"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            class="w-100 mb-0"
            placeholder="القرية"
            :clearable="true"
            :disabled="!filter.city_id"
          />
        </b-col>

        <!-- LandsurveyOrder filters -->
        <b-col cols="12">
          <h5 class="ml-1">
            فلاتر الرفع المساحي
          </h5>
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="survey-filter"
        >
          <v-select
            v-model="filter.landsurvey_review_status"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="landsurveyReviewStatusOptions"
            class="w-100 mb-0"
            :reduce="(val) => val"
            placeholder="حالة المراجعة"
            :clearable="true"
          >
            <template v-slot:option="option">
              {{ option.label }}
            </template>
            <template #selected-option="option">
              <div style="display: flex; align-items: baseline">
                <strong>{{ option.label }}</strong>
              </div>
            </template>
            <template #no-options>
              {{ $t("noMatching") }}
            </template>
          </v-select>
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="survey-filter"
        >
          <v-select
            v-model="filter.landsurvey_survey_status"
            :dir="$store.state.appConfig.layout.isRTL ? 'rtl' : 'ltr'"
            :options="landsurveySurveyStatusOptions"
            class="w-100 mb-0"
            :reduce="(val) => val"
            placeholder="حالة الرفع المساحي"
            :clearable="true"
          >
            <template v-slot:option="option">
              {{ option.label }}
            </template>
            <template #selected-option="option">
              <div style="display: flex; align-items: baseline">
                <strong>{{ option.label }}</strong>
              </div>
            </template>
            <template #no-options>
              {{ $t("noMatching") }}
            </template>
          </v-select>
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="survey-filter"
        >
          <flat-pickr
            v-model="filter.landsurvey_survey_date_from"
            class="form-control"
            :config="{ dateFormat: 'Y-m-d', placeholder: 'من تاريخ' }"
            placeholder="من تاريخ"
          />
        </b-col>
        <b-col
          cols="12"
          md="3"
          class="survey-filter"
        >
          <flat-pickr
            v-model="filter.landsurvey_survey_date_to"
            class="form-control"
            :config="{ dateFormat: 'Y-m-d', placeholder: 'إلى تاريخ' }"
            placeholder="إلى تاريخ"
          />
        </b-col>

      </b-row>
    </b-card>
    <b-card class="w-100 d-flex rounded-lg">
      <b-row class="mt-0">
        <b-col
          cols="12"
          class="projects-toolbar-actions mb-2 mb-md-0"
        >
          <div class="projects-toolbar-actions__scroller d-flex flex-row flex-nowrap justify-content-end align-items-center gap-2">
          <b-button
            v-if="hasPermission('view projects')"
            v-b-tooltip.hover.bottom="'تصدير خط السير Excel'"
            class="btn rounded-pill projects-action-btn flex-shrink-0"
            variant="outline-success"
            size="sm"
            :disabled="routePlanExportDisabled"
            @click="exportRoutePlan('excel')"
          >
            <b-spinner
              v-if="routePlanExportLoading && routePlanExportFormat === 'excel'"
              small
              class="projects-action-btn__icon"
            />
            <span class="d-none d-md-inline">📥 تصدير Excel</span>
            <span class="d-inline d-md-none">📥 Excel</span>
          </b-button>
          
          <b-button
            v-if="hasPermission('view projects')"
            v-b-tooltip.hover.bottom="'تصدير خط السير PDF'"
            class="btn rounded-pill projects-action-btn flex-shrink-0"
            variant="outline-danger"
            size="sm"
            :disabled="routePlanExportLoading"
            @click="exportRoutePlan('pdf')"
          >
            <b-spinner
              v-if="routePlanExportLoading && routePlanExportFormat === 'pdf'"
              small
              class="projects-action-btn__icon"
            />
            <span class="d-none d-md-inline">📄 تصدير PDF</span>
            <span class="d-inline d-md-none">📄 PDF</span>
          </b-button>
          <b-button
            v-if="hasPermission('view projects')"
            v-b-tooltip.hover.bottom="'الخرائط'"
            class="btn rounded-pill projects-action-btn flex-shrink-0"
            variant="primary"
            size="sm"
            @click="gotoProjectsMap()"
          >
            <feather-icon
              icon="MapIcon"
              size="14"
              class="projects-action-btn__icon"
            />
            <span class="d-none d-md-inline">الخرائط</span>
          </b-button>
          <b-button
            v-if="hasPermission('create projects') && hasRole('halawany')"
            v-b-tooltip.hover.bottom="'أضافة مشروع'"
            class="btn rounded-pill projects-action-btn flex-shrink-0"
            variant="primary"
            size="sm"
            @click="gotoAddPro()"
          >
            <feather-icon
              icon="PlusIcon"
              size="14"
              class="projects-action-btn__icon"
            />
            <span class="d-none d-md-inline">أضافة مشروع</span>
          </b-button>
          <b-button
            v-if="hasRole('admin')"
            v-b-tooltip.hover.bottom="'استيراد أوامر الرفع المساحي 168'"
            class="btn rounded-pill projects-action-btn flex-shrink-0"
            variant="primary"
            size="sm"
            @click="importOrderSurvey()"
          >
            <feather-icon
              icon="UploadIcon"
              size="14"
              class="projects-action-btn__icon"
            />
            <span class="d-none d-md-inline">استيراد أوامر الرفع المساحي 168</span>
          </b-button>
          <b-button
            v-if="hasPermission('create projects')"
            v-b-tooltip.hover.bottom="'أضافة مشروع 168'"
            class="btn rounded-pill projects-action-btn flex-shrink-0"
            variant="primary"
            size="sm"
            @click="gotoAddPro_168()"
          >
            <feather-icon
              icon="PlusIcon"
              size="14"
              class="projects-action-btn__icon"
            />
            <span class="d-none d-md-inline">أضافة مشروع 168</span>
          </b-button>
          <b-button
            v-if="hasPermission('create seizure_land_inventories') || hasPermission('create projects')"
            v-b-tooltip.hover.bottom="'مشروع استيلاء جديد'"
            class="btn rounded-pill projects-action-btn flex-shrink-0"
            variant="primary"
            size="sm"
            @click="gotoSeizureInventory()"
          >
            <feather-icon
              icon="PlusIcon"
              size="14"
              class="projects-action-btn__icon"
            />
            <span class="d-none d-md-inline">مشروع استيلاء جديد</span>
          </b-button>
          <b-button
            v-if="hasPermission('edit projects')"
            v-b-tooltip.hover.bottom="'استيراد KML متعدد المشاريع'"
            class="btn rounded-pill projects-action-btn flex-shrink-0"
            variant="primary"
            size="sm"
            @click="gotoMultiProjectsKMLImport()"
          >
            <feather-icon
              icon="UploadIcon"
              size="14"
              class="projects-action-btn__icon"
            />
            <span class="d-none d-md-inline">استيراد KML متعدد المشاريع</span>
          </b-button>
          </div>
        </b-col>
      </b-row>

      <b-row
        v-if="hasPermission('view projects')"
        class="mt-1 mb-2 align-items-center"
      >
        <b-col
          cols="12"
          md="auto"
        >
          <b-form-radio-group
            v-model="routePlanSelectionMode"
            :options="routePlanSelectionOptions"
            buttons
            button-variant="outline-primary"
            size="sm"
            @change="onRoutePlanSelectionModeChange"
          />
        </b-col>
        <b-col
          v-if="selectedProjectIds.length"
          cols="12"
          md="auto"
          class="mt-1 mt-md-0"
        >
          <span class="text-muted small">
            محدد: <strong class="text-primary">{{ selectedProjectIds.length }}</strong>
            مشروع / {{ selectedProjectIds.length }} project{{ selectedProjectIds.length === 1 ? '' : 's' }} selected
            <b-button
              variant="link"
              size="sm"
              class="p-0 mr-1"
              @click="clearProjectSelection"
            >
              إلغاء التحديد
            </b-button>
          </span>
        </b-col>
        <b-col
          v-if="selectedProjectIds.length && hasPermission('view projects')"
          cols="12"
          md="auto"
          class="mt-1 mt-md-0 d-flex flex-wrap align-items-center gap-2"
        >
          <b-button
            variant="outline-primary"
            size="sm"
            class="projects-action-btn flex-shrink-0"
            :disabled="bulkKmlExportLoading || bulkShapeExportLoading"
            @click="openBulkKmlExportModal"
          >
            <b-spinner
              v-if="bulkKmlExportLoading"
              small
              class="projects-action-btn__icon"
            />
            <feather-icon
              v-else
              icon="DownloadIcon"
              size="14"
              class="projects-action-btn__icon"
            />
            تصدير KML / Export KML
          </b-button>
          <b-button
            variant="outline-primary"
            size="sm"
            class="projects-action-btn flex-shrink-0"
            :disabled="bulkKmlExportLoading || bulkShapeExportLoading"
            @click="openBulkShapeExportModal"
          >
            <b-spinner
              v-if="bulkShapeExportLoading"
              small
              class="projects-action-btn__icon"
            />
            <feather-icon
              v-else
              icon="DownloadIcon"
              size="14"
              class="projects-action-btn__icon"
            />
            تصدير Shapefile / Export Shapefile
          </b-button>
        </b-col>
        <b-col
          v-else
          cols="12"
          md="auto"
          class="mt-1 mt-md-0"
        >
          <span class="text-muted small">
            سيتم التصدير لجميع المشاريع المطابقة للفلاتر
            <strong class="text-primary">({{ filteredProjectsTotal }})</strong>
          </span>
        </b-col>
      </b-row>

      <!-- Error state: clear message + retry -->
      <b-alert
        v-if="loadError"
        variant="danger"
        show
        dismissible
        class="d-flex align-items-center"
        @dismissed="loadError = null"
      >
        <feather-icon
          icon="AlertCircleIcon"
          size="24"
          class="mr-2"
        />
        <div class="flex-grow-1">
          <strong>فشل تحميل المشاريع</strong>
          <p class="mb-0 mt-1 small">
            {{ loadError }}
          </p>
        </div>
        <b-button
          variant="outline-danger"
          size="sm"
          @click="retryLoad"
        >
          <feather-icon
            icon="RefreshCwIcon"
            size="14"
            class="mr-50"
          />
          إعادة المحاولة
        </b-button>
      </b-alert>

      <!-- Skeleton table: show while loading so user sees structure -->
      <div
        v-if="load"
        class="projects-table-skeleton"
      >
        <b-table
          striped
          responsive
          :items="skeletonRows"
          :fields="fields"
          class="mb-0 skeleton-table"
        >
          <template #cell(surveying_code)="">
            <div
              class="skeleton-bar"
              style="width: 70%"
            />
          </template>
          <template #cell(name)="">
            <div
              class="skeleton-bar"
              style="width: 85%"
            />
          </template>
          <template #cell(status)="">
            <div
              class="skeleton-bar"
              style="width: 50%"
            />
          </template>
          <template #cell(current_execution_status)="">
            <div
              class="skeleton-bar"
              style="width: 60%"
            />
          </template>
          <template #cell(owners)="">
            <div
              class="skeleton-bar"
              style="width: 55%"
            />
          </template>
          <template #cell(phone)="">
            <div
              class="skeleton-bar"
              style="width: 50%"
            />
          </template>
          <template #cell(budget)="">
            <div
              class="skeleton-bar"
              style="width: 45%"
            />
          </template>
          <template #cell(actual_cost)="">
            <div
              class="skeleton-bar"
              style="width: 45%"
            />
          </template>
          <template #cell(actions)="">
            <div
              class="skeleton-bar skeleton-actions"
              style="width: 80px"
            />
          </template>
        </b-table>
        <div class="text-center py-3 text-muted">
          <b-spinner
            small
            variant="primary"
            class="mr-50"
          />
          <span>جاري تحميل المشاريع...</span>
        </div>
      </div>

      <template v-else>
        <!-- Desktop Table View -->
        <div class="d-none d-md-block">
          <b-table
            striped
            responsive
            :items="tableData"
            :fields="fields"
            show-empty
            empty-text="لا توجد مشاريع متاحة"
            empty-filtered-text="لا توجد مشاريع تطابق البحث"
            :busy="false"
          >
            <template
              v-if="hasPermission('view projects')"
              #head(selected)
            >
              <b-form-checkbox
                :checked="allPageSelected"
                :indeterminate="pageSelectionIndeterminate"
                @change="toggleSelectAllOnPage"
              />
            </template>
            <template
              v-if="hasPermission('view projects')"
              #cell(selected)="data"
            >
              <b-form-checkbox
                :checked="isProjectSelected(data.item.id)"
                @change="toggleProjectSelection(data.item.id, $event)"
              />
            </template>
            <template #cell(surveying_code)="data">
              <div class="d-flex align-items-center">
                <b-link
                  v-b-tooltip.hover.bottom="'عرض تفاصيل المشروع'"
                  :class="[
                    'surveying-code-cell text-primary',
                    { 'surveying-code-red': data.item.color === 'red' }
                  ]"
                  style="cursor: pointer; text-decoration: none;"
                  @click="goToProjectDetails(data.item)"
                >
                  {{ data.item.surveying_code }}
                </b-link>
                <feather-icon
                  v-if="data.item.surveying_code"
                  v-b-tooltip.hover.bottom="'نسخ الكود المساحي'"
                  icon="CopyIcon"
                  size="14"
                  class="ml-1 text-muted cursor-pointer"
                  @click.stop="copySurveyingCode(data.item.surveying_code)"
                />
              </div>
            </template>
            <template #cell(project_number)="data">
              <b-link
                v-b-tooltip.hover.bottom="'عرض الخريطة'"
                class=" ml-1 text-primary"
                @click="openCoordinatesMap(data.item)"
              >
                {{ data.item.project_number }}
              </b-link>
            </template>
            <template #cell(owners)="data">
              <!-- Show authorized client first if exists -->
              <div v-if="data.item.authorizedClient">
                <b-link
                  v-b-tooltip.hover.bottom="'عرض مقدم الطلب'"
                  class="text-primary"
                  target="_blank"
                  :to="{ name: 'customerDetails', params: { id: data.item.authorizedClient.id} }"
                >
                  مقدم الطلب: {{ data.item.authorizedClient.name }}
                </b-link>
              </div>
              <!-- Show owners only if first owner is not the same as authorized client -->
              <template v-if="data.item.owners && data.item.owners.length > 0">
                <div
                  v-for="owner in data.item.owners"
                  :key="owner.id"
                >
                  <template v-if="!data.item.authorizedClient || owner.id !== data.item.authorizedClient.id">
                    <b-link
                      v-b-tooltip.hover.bottom="'عرض المالك'"
                      class="text-primary"
                      target="_blank"
                      :to="{ name: 'customerDetails', params: { id: owner.id} }"
                    >
                      صاحب الشأن: {{ owner.name }}
                    </b-link>
                  </template>
                </div>
              </template>
            </template>
            <template #cell(phone)="data">
              <!-- Show authorized client phone first if exists -->
              <div v-if="data.item.authorizedClient && data.item.authorizedClient.phone">
                <div class="d-flex align-items-center">
                  مقدم الطلب:
                  <a
                    v-b-tooltip.hover.bottom="'اتصال بمقدم الطلب'"
                    :href="`tel:${data.item.authorizedClient.phone}`"
                    class="text-success d-inline-flex align-items-center mr-1"
                  >
                    {{ data.item.authorizedClient.phone }}
                    <feather-icon
                      icon="PhoneIcon"
                      size="14"
                      class="ml-1"
                    />
                  </a>
                  <a
                    v-b-tooltip.hover.bottom="'فتح WhatsApp'"
                    :href="`https://wa.me/${formatPhoneForWhatsApp(data.item.authorizedClient.phone)}`"
                    target="_blank"
                    class="text-success d-inline-flex align-items-center"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                    </svg>
                  </a>
                </div>
              </div>
              <!-- Show owner phone only if first owner is not the same as authorized client -->
              <template v-if="data.item.owners && data.item.owners.length > 0">
                <div
                  v-for="owner in data.item.owners"
                  :key="owner.id"
                >
                  <template v-if="owner.phone && (!data.item.authorizedClient || owner.id !== data.item.authorizedClient.id)">
                    <div class="d-flex align-items-center">
                      صاحب الشأن:
                      <a
                        v-b-tooltip.hover.bottom="'اتصال'"
                        :href="`tel:${owner.phone}`"
                        class="text-success d-inline-flex align-items-center mr-2"
                      >
                        {{ owner.phone }}
                        <feather-icon
                          icon="PhoneIcon"
                          size="14"
                          class="ml-1"
                        />
                      </a>
                      <a
                        v-b-tooltip.hover.bottom="'فتح WhatsApp'"
                        :href="`https://wa.me/${formatPhoneForWhatsApp(owner.phone)}`"
                        target="_blank"
                        class="text-success d-inline-flex align-items-center"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                        </svg>
                      </a>
                    </div>
                  </template>
                </div>
              </template>
              <span
                v-if="(!data.item.authorizedClient || !data.item.authorizedClient.phone) && (!data.item.owners || data.item.owners.length === 0 || !data.item.owners.some(o => o.phone && (!data.item.authorizedClient || o.id !== data.item.authorizedClient.id)))"
                class="text-muted d-block"
              >-</span>
            </template>
            <template #cell(current_execution_status)="data">
              <div class="d-flex align-items-center">
                <b-badge
                  v-if="data.item.current_execution_status"
                  variant="light-primary"
                  class="mr-50"
                >
                  {{ data.item.current_execution_status }}
                </b-badge>
                <span
                  v-if="hasPermission('edit projects')"
                  v-b-tooltip.hover.bottom="'تحديث الحالة التنفيذية'"
                  class="d-inline-flex align-items-center"
                >
                  <feather-icon
                    icon="Edit2Icon"
                    size="16"
                    class="text-info cursor-pointer"
                    @click="openUpdateExecutionStatusModal(data.item)"
                  />
                </span>
              </div>
            </template>
            <template #cell(actions)="data">
              <div
                v-if="data.item"
                class="d-flex align-items-center"
              >
                <div v-if="data.item.deleted_at == null">
                  <!--<b-link
                    v-if="hasPermission('edit projects')"
                    class="cutom-alert-link"
                    :to="{ name: 'edit_project', params: { id: data.item.id} }"
                    v-b-tooltip.hover.bottom="'تعديل المشروع'"
                  >
                    <feather-icon icon="EditIcon" size="18" />
                  </b-link> -->

                  <feather-icon
                    v-if="hasPermission('edit projects')"
                    v-b-tooltip.hover.bottom="'تغيير حالة المشروع'"
                    icon="Edit2Icon"
                    size="18"
                    @click="openUpdateProjectStatusModal(data.item)"
                  />

                  <b-link
                    v-if="hasPermission('view projects')"
                    v-b-tooltip.hover.bottom="'عرض المشروع'"
                    class=" ml-1 text-primary"
                    :to="{ name: 'project_details', params: { id: data.item.id} }"
                  >
                    <feather-icon
                      icon="EyeIcon"
                      size="18"
                    />
                  </b-link>
                  <b-link
                    v-if="hasPermission('edit projects')"
                    v-b-tooltip.hover.bottom="'تعديل المشروع'"
                    class="text-info ml-1"
                    :to="{ name: 'edit_project', params: { id: data.item.id} }"
                  >
                    <feather-icon
                      icon="EditIcon"
                      size="18"
                    />
                  </b-link>
                  <feather-icon
                    v-if="hasPermission('delete projects')"
                    v-b-tooltip.hover.bottom="'حذف المشروع'"
                    icon="TrashIcon"
                    size="18"
                    class="text-danger ml-1"
                    @click="deleteProject(data.item)"
                  />
                </div>

                <div v-if="data.item.deleted_at != null">
                  <feather-icon
                    v-if="hasPermission('delete projects')"
                    v-b-tooltip.hover.bottom="'استعادة المشروع'"
                    icon="RefreshCwIcon"
                    size="18"
                    class="text-success ml-1"
                    @click="restoreProject(data.item)"
                  />
                  <feather-icon
                    v-if="hasPermission('delete projects')"
                    v-b-tooltip.hover.bottom="'حذف المشروع بشكل نهائي'"
                    icon="TrashIcon"
                    size="18"
                    class="text-danger ml-1"
                    @click="hardDeleteProject(data.item)"
                  />
                </div>
              </div>
            </template>
          </b-table>
        </div>

        <!-- Mobile Card View -->
        <div class="d-md-none">
          <div
            v-for="(item, index) in tableData"
            :key="item.id || index"
            class="project-card-mobile"
          >
            <b-card
              class="shadow-sm border"
              style="background-color: #c5f6e6"
            >
              <div class="project-card-header">
                <div class="d-flex justify-content-between align-items-start">
                  <div class="flex-grow-1 d-flex align-items-center">
                    <b-form-checkbox
                      v-if="hasPermission('view projects')"
                      :checked="isProjectSelected(item.id)"
                      class="ml-2"
                      @change="toggleProjectSelection(item.id, $event)"
                    />
                    <b-link
                      v-b-tooltip.hover.bottom="'عرض تفاصيل المشروع'"
                      class="font-weight-bold text-primary"
                      :class="{ 'surveying-code-red': item.color === 'red' }"
                      style="cursor: pointer; text-decoration: none;"
                      @click="goToProjectDetails(item)"
                    >
                      {{ item.surveying_code }}
                    </b-link>
                    <feather-icon
                      v-if="item.surveying_code"
                      v-b-tooltip.hover.bottom="'نسخ الكود المساحي'"
                      icon="CopyIcon"
                      size="14"
                      class="ml-1 text-muted cursor-pointer"
                      @click.stop="copySurveyingCode(item.surveying_code)"
                    />
                  </div>
                </div>
              </div>

              <div class="project-card-body">
                <!-- Show authorized client first if exists -->
                <div
                  v-if="item.authorizedClient"
                  class="project-info-item"
                >
                  <b-link
                    class="text-primary d-block "
                    target="_blank"
                    :to="{ name: 'customerDetails', params: { id: item.authorizedClient.id} }"
                  >
                    مقدم الطلب: {{ item.authorizedClient.name }}
                  </b-link>
                  <div
                    v-if="item.authorizedClient.phone"
                    class="d-flex align-items-center "
                  >
                    <a
                      v-b-tooltip.hover.bottom="'اتصال بمقدم الطلب'"
                      :href="`tel:${item.authorizedClient.phone}`"
                      class="text-primary phone-link d-flex align-items-center mr-2"
                    >
                      <feather-icon
                        icon="PhoneIcon"
                        size="14"
                        class="mr-50"
                      />
                      {{ item.authorizedClient.phone }}
                    </a>
                    <a
                      v-b-tooltip.hover.bottom="'فتح WhatsApp'"
                      :href="`https://wa.me/${formatPhoneForWhatsApp(item.authorizedClient.phone)}`"
                      target="_blank"
                      class="text-success d-inline-flex align-items-center"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                      </svg>
                    </a>
                  </div>
                </div>
                <!-- Show owners only if first owner is not the same as authorized client -->
                <div
                  v-if="item.owners && item.owners.length > 0"
                  class="project-info-item"
                >
                  <template v-for="owner in item.owners">
                    <div
                      v-if="!item.authorizedClient || owner.id !== item.authorizedClient.id"
                      :key="owner.id"
                    >
                      <b-link
                        class="text-primary d-block"
                        target="_blank"
                        :to="{ name: 'customerDetails', params: { id: owner.id} }"
                      >
                        صاحب الشأن: {{ owner.name }}
                      </b-link>
                      <div
                        v-if="owner.phone"
                        class="d-flex align-items-center"
                      >
                        <a
                          v-b-tooltip.hover.bottom="'اتصال'"
                          :href="`tel:${owner.phone}`"
                          class="text-primary phone-link d-flex align-items-center mr-2"
                        >
                          <feather-icon
                            icon="PhoneIcon"
                            size="14"
                            class="mr-50"
                          />
                          {{ owner.phone }}
                        </a>
                        <a
                          v-b-tooltip.hover.bottom="'فتح WhatsApp'"
                          :href="`https://wa.me/${formatPhoneForWhatsApp(owner.phone)}`"
                          target="_blank"
                          class="text-success d-inline-flex align-items-center"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                          >
                            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                          </svg>
                        </a>
                      </div>
                    </div>
                  </template>
                </div>
                <div
                  v-if="item.current_custom_task_name || item.unit_type_or_activity || item.area_m2"
                  class="project-info-item"
                >
                  <div class="d-flex flex-wrap align-items-center gap-2">
                    <div
                      v-if="item.current_custom_task_name"
                      class="info-badge"
                    >
                      <feather-icon
                        icon="CheckIcon"
                        size="12"
                        class=""
                      />
                      <span>{{ item.current_custom_task_name }}</span>
                    </div>
                    <div
                      v-if="item.unit_type_or_activity"
                      class="info-badge"
                    >
                      <feather-icon
                        icon="GridIcon"
                        size="12"
                        class=""
                      />
                      <span>{{ item.unit_type_or_activity }}</span>
                    </div>
                    <div
                      v-if="item.area_m2"
                      class="info-badge"
                    >
                      <feather-icon
                        icon="SquareIcon"
                        size="12"
                        class=""
                      />
                      <span>{{ item.area_m2 }} {{ item.unit_type_or_activity == 'ارض' || item.unit_type_or_activity == 'أرض' ? 'فدان' : ' م2' }} </span>
                    </div>
                  </div>
                </div>
                <div
                  v-if="item.governorate || item.center || item.city || item.district || item.village"
                  class="project-info-item"
                >
                  <div class="location-info">
                    <span v-if="item.governorate && item.governorate.name">{{ item.governorate.name }}</span>
                    <span v-if="item.governorate && item.governorate.name && (item.center || item.city || item.district || item.village)"> - </span>
                    <span v-if="item.center && item.center.name">{{ item.center.name }}</span>
                    <span v-if="item.center && item.center.name && (item.city || item.district || item.village)"> - </span>
                    <span v-if="item.city && item.city.name">{{ item.city.name }}</span>
                    <span v-if="item.city && item.city.name && (item.district || item.village)"> - </span>
                    <span v-if="item.district && item.district.name">{{ item.district.name }}</span>
                    <span v-if="item.district && item.district.name && item.village"> - </span>
                    <span v-if="item.village && item.village.name">{{ item.village.name }}</span>
                  </div>
                </div>
              </div>

              <div
                v-if="hasRole('admin')"
                class="project-card-actions border-top"
              >
                <div class="d-flex flex-wrap justify-content-start align-items-center">
                  <feather-icon
                    v-if="item.deleted_at == null && hasPermission('edit projects')"
                    v-b-tooltip.hover.bottom="'تغيير حالة المشروع'"
                    icon="Edit2Icon"
                    size="16"
                    class="mr-2  text-info"
                    @click="openUpdateProjectStatusModal(item)"
                  />

                  <b-link
                    v-if="item.deleted_at == null"
                    v-b-tooltip.hover.bottom="'عرض المشروع'"
                    class="mr-2  text-primary"
                    :to="{ name: 'project_details', params: { id: item.id} }"
                  >
                    <feather-icon
                      icon="EyeIcon"
                      size="16"
                    />
                  </b-link>

                  <b-link
                    v-if="item.deleted_at == null && hasPermission('edit projects')"
                    v-b-tooltip.hover.bottom="'تعديل المشروع'"
                    class="mr-2  text-info"
                    :to="{ name: 'edit_project', params: { id: item.id} }"
                  >
                    <feather-icon
                      icon="EditIcon"
                      size="16"
                    />
                  </b-link>

                  <feather-icon
                    v-if="item.deleted_at == null && hasPermission('delete projects')"
                    v-b-tooltip.hover.bottom="'حذف المشروع'"
                    icon="TrashIcon"
                    size="16"
                    class="mr-2 text-danger"
                    @click="deleteProject(item)"
                  />

                  <div
                    v-if="item.deleted_at != null && hasPermission('delete projects')"
                    class="d-flex align-items-center"
                  >
                    <feather-icon
                      v-b-tooltip.hover.bottom="'استعادة المشروع'"
                      icon="RefreshCwIcon"
                      size="16"
                      class="mr-2 text-success"
                      @click="restoreProject(item)"
                    />
                    <feather-icon
                      v-if="hasPermission('delete projects')"
                      v-b-tooltip.hover.bottom="'حذف المشروع بشكل نهائي'"
                      icon="TrashIcon"
                      size="16"
                      class="mr-2 text-danger"
                      @click="hardDeleteProject(item)"
                    />
                  </div>
                </div>
              </div>
            </b-card>
          </div>

          <div
            v-if="tableData.length === 0"
            class="text-center py-5 text-muted"
          >
            <p class="mb-0">
              لا توجد مشاريع متاحة
            </p>
          </div>
        </div>
      </template>

      <!-- Results Summary -->
      <div
        v-if="items && items.meta && !load"
        class="mb-2 mt-3"
      >
        <div class="d-flex justify-content-between align-items-center">
          <div class="text-muted small">
            <span>إجمالي المشاريع: <strong class="text-primary">{{ items.meta.total || 0 }}</strong></span>
            <span class="mr-3">|</span>
            <span>عرض <strong class="text-primary">{{ getCurrentRowsRange() }}</strong> من {{ items.meta.total || 0 }}</span>
          </div>
          <div class="d-flex align-items-center">
            <span class="text-muted small ml-1">لكل صفحة:</span>
            <b-form-select
              v-model.number="filter.per_page"
              :options="perPageOptions"
              size="sm"
              class="ml-1"
            />
          </div>
        </div>
      </div>

      <!-- Pagination: show when we have meta; disable while loading -->
      <b-pagination
        v-if="items && items.meta && (load || items.meta.total > 0)"
        v-model="items.meta.current_page"
        align="center"
        :total-rows="(items.meta && items.meta.total) || 0"
        :per-page="(items.meta && items.meta.per_page) || perPage"
        :disabled="load"
        @change="onPageChange"
      />
    </b-card>
    <b-modal
      id="update-project-status-modal"
      title="تغيير حالة المشروع"
      class="project-modal"
      @ok="updateProjectStatus"
    >
      <b-form-group
        label="الحالة"
        label-for="project-status"
      >
        <b-form-select
          id="project-status"
          v-model="selectedStatus"
          :options="status_data"
        />
      </b-form-group>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="secondary"
          size="sm"
          @click="cancel"
        >
          إلغاء
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          @click="ok"
        >
          تحديث
        </b-button>
      </template>
    </b-modal>

    <b-modal
      id="update-execution-status-modal"
      title="تحديث الحالة التنفيذية"
      class="project-modal"
      @ok="updateExecutionStatus"
    >
      <b-form-group
        label="الحالة التنفيذية"
        label-for="execution-status"
      >
        <b-form-select
          id="execution-status"
          v-model="selectedExecutionStatus"
          :options="executionStatusOptionsWithoutAll"
          :disabled="loadCurrentExecutionStatus"
        />
      </b-form-group>
      <template #modal-footer="{ ok, cancel }">
        <b-button
          variant="secondary"
          size="sm"
          :disabled="loadCurrentExecutionStatus"
          @click="cancel"
        >
          إلغاء
        </b-button>
        <b-button
          variant="primary"
          size="sm"
          :disabled="loadCurrentExecutionStatus || !selectedExecutionStatus"
          @click="ok"
        >
          <b-spinner
            v-if="loadCurrentExecutionStatus"
            small
            class="mr-50"
          />
          تحديث
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showBulkKmlExportModal"
      title="تصدير KML للمشاريع المحددة / Export Selected Projects KML"
      ok-title="تصدير / Export"
      cancel-title="إلغاء / Cancel"
      :ok-disabled="bulkKmlExportLoading"
      @ok="confirmBulkKmlExport"
    >
      <b-form-group
        label="ملاحظة رأس التقرير (اختياري) / Header note (optional)"
        label-for="bulk-kml-header-note"
      >
        <b-form-textarea
          id="bulk-kml-header-note"
          v-model="bulkKmlHeaderNote"
          rows="4"
          :maxlength="KML_HEADER_NOTE_MAX_LENGTH"
          :disabled="bulkKmlExportLoading"
          placeholder="Optional note shown in all exported KML descriptions"
        />
      </b-form-group>
      <small class="text-muted">
        {{ bulkKmlHeaderNote.length }}/{{ KML_HEADER_NOTE_MAX_LENGTH }}
      </small>
    </b-modal>

    <b-modal
      v-model="showBulkShapeExportModal"
      title="تصدير Shapefile للمشاريع المحددة / Export Selected Projects Shapefile"
      ok-title="تصدير / Export"
      cancel-title="إلغاء / Cancel"
      :ok-disabled="bulkShapeExportLoading || shapeSchemasLoading || !selectedShapeSchemaId"
      @shown="loadShapeSchemasForExport"
      @ok="confirmBulkShapeExport"
    >
      <b-form-group
        label="Schema"
        label-for="bulk-shape-schema"
      >
        <b-form-select
          id="bulk-shape-schema"
          v-model="selectedShapeSchemaId"
          :options="bulkShapeSchemaOptions"
          :disabled="shapeSchemasLoading || bulkShapeExportLoading"
        />
      </b-form-group>
      <b-form-group
        label="Coordinate type"
        label-for="bulk-shape-type"
      >
        <b-form-select
          id="bulk-shape-type"
          v-model="bulkShapeExportType"
          :options="bulkShapeTypeOptions"
          :disabled="bulkShapeExportLoading"
        />
      </b-form-group>
      <small
        v-if="shapeSchemasLoading"
        class="text-muted"
      >
        Loading schemas...
      </small>
    </b-modal>
  </div>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import {
  BTable,
  BButton,
  BFormCheckbox,
  BCard,
  BRow,
  BCol,
  BBadge,
  BCardText,
  BAvatar,
  BLink,
  VBTooltip,
  BSpinner,
  BPagination,
  BFormInput,
  BInputGroup,
  BForm,
  BFormGroup,
  BFormSelect,
  BAlert,
  BFormRadioGroup,
  BModal,
  BFormTextarea,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { mapGetters } from 'vuex'
import vSelect from 'vue-select'

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  required, email, phone, national_id,
} from '@validations'
import FeatherIcon from '@/@core/components/feather-icon/FeatherIcon.vue'
import Projects from '@/api/projects/projects'
import projectShapeSchemasApi from '@/api/settings/projectShapeSchemas'
import flatPickr from 'vue-flatpickr-component'

const KML_HEADER_NOTE_STORAGE_KEY = 'kmlExportHeaderNote'
const KML_HEADER_NOTE_MAX_LENGTH = 2000

export default {
  components: {
    BTable,
    BButton,
    BFormCheckbox,
    BCard,
    BForm,
    BRow,
    BCol,
    BBadge,
    BFormGroup,
    BAvatar,
    BInputGroup,
    ToastificationContent,
    ValidationProvider,
    ValidationObserver,
    BCardText,
    vSelect,
    BLink,
    BSpinner,
    BPagination,
    BFormInput,
    FeatherIcon,
    BFormSelect,
    BAlert,
    BFormRadioGroup,
    BModal,
    BFormTextarea,
    flatPickr,
  },
  computed: {
    ...mapGetters({
      items: 'projects/projects',
      load: 'projects/load',
      loadCurrentExecutionStatus: 'projects/loadCurrentExecutionStatus',
      serviceTypes: 'serviceTypes/serviceTypes',
      governorates: 'settings/governorates',
      centers: 'settings/centers',
      cities: 'settings/cities',
      villages: 'settings/villages',
    }),
    /** Safe list for table; avoids undefined when store not yet loaded */
    tableData() {
      return (this.items && this.items.data) ? this.items.data : []
    },
    filteredProjectsTotal() {
      return (this.items && this.items.meta && this.items.meta.total) || 0
    },
    /** Fake rows for skeleton table (same columns, no real data) */
    skeletonRows() {
      return Array.from({ length: this.skeletonRowCount }, () => ({}))
    },
    executionStatusOptions() {
      return [{ value: null, text: 'الحالة التنفيذية: الكل' }, ...this.current_execution_status_data.map(v => ({ value: v, text: v }))]
    },
    executionStatusOptionsWithoutAll() {
      return this.current_execution_status_data.map(v => ({ value: v, text: v }))
    },
    routePlanSelectionOptions() {
      return [
        { text: 'كل المشاريع المفلترة', value: 'all' },
        { text: 'اختيار مخصص', value: 'custom' },
      ]
    },
    allPageSelected() {
      if (!this.tableData.length) return false
      return this.tableData.every(item => this.selectedProjectIds.includes(item.id))
    },
    pageSelectionIndeterminate() {
      if (!this.tableData.length) return false
      const selectedOnPage = this.tableData.filter(item => this.selectedProjectIds.includes(item.id)).length
      return selectedOnPage > 0 && selectedOnPage < this.tableData.length
    },
    routePlanExportDisabled() {
      if (this.routePlanExportLoading) return true
      if (this.routePlanSelectionMode === 'custom') {
        return this.selectedProjectIds.length === 0
      }
      return false
    },
    bulkShapeSchemaOptions() {
      const options = [{ value: null, text: 'Select schema...', disabled: true }]
      this.shapeSchemas.forEach(schema => {
        options.push({
          value: schema.id,
          text: schema.name,
        })
      })
      return options
    },
    fields() {
      const baseFields = [
        { key: 'surveying_code', label: 'الكود المساحي', sortable: true },
        // { key: "project_number", label: "project number" ,sortable: true},
        { key: 'status', label: 'الحالة', sortable: true },
        // { key: "current_execution_status", label: "الحالة التنفيذية" ,sortable: false},
        { key: 'owners', label: 'صاحب الشأن', sortable: true },
        { key: 'phone', label: 'الهاتف', sortable: false },
        // { key: "budget", label: "التكلفة" ,sortable: true},
        // { key: "actual_cost", label: "التكلفة الفعلية" ,sortable: true},
        {
          key: 'Actions', label: 'الإجراءات', sortable: false, width: '15%',
        },
      ]

      // Add "name" field only if user has admin role
      if (this.hasRole('admin')) {
        baseFields.splice(1, 0, { key: 'name', label: 'اسم المشروع', sortable: true })
      }

      if (this.hasPermission('view projects')) {
        baseFields.unshift({ key: 'selected', label: '', thStyle: { width: '40px' } })
      }

      return baseFields
    },
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  watch: {
    'filter.service_type_id': function (newVal) {
      newVal == '' ? this.filter.service_type_id = null : this.filter.service_type_id = newVal
      this.onFilterChanged()
    },
    'filter.search': function (newVal) {
      newVal == '' ? this.filter.search = null : this.filter.search = newVal
      this.debouncedFilterChanged()
    },
    'filter.status': function (newVal) {
      newVal == '' ? this.filter.status = null : this.filter.status = newVal
      this.onFilterChanged()
    },
    'filter.current_execution_status': function () {
      this.onFilterChanged()
    },
    'filter.custom_task_id': function () {
      this.onFilterChanged()
    },
    'filter.custom_task_status': function () {
      this.onFilterChanged()
    },
    'filter.owner_name': function () {
      this.debouncedFilterChanged()
    },
    'filter.owner_national_id': function () {
      this.debouncedFilterChanged()
    },
    'filter.owner_phone': function () {
      this.debouncedFilterChanged()
    },
    'filter.owner_mobile': function () {
      this.debouncedFilterChanged()
    },
    'filter.governorate_id': function (newVal) {
      // clear children
      this.filter.center_id = null
      this.filter.city_id = null
      this.filter.village_id = null
      if (newVal) {
        this.$store.dispatch('settings/listCenters', { query: { governorate_id: newVal } })
      }
      this.onFilterChanged()
    },
    'filter.center_id': function (newVal) {
      this.filter.city_id = null
      this.filter.village_id = null
      if (newVal) {
        this.$store.dispatch('settings/listCities', { query: { center_id: newVal } })
      }
      this.onFilterChanged()
    },
    'filter.city_id': function (newVal) {
      this.filter.village_id = null
      if (newVal) {
        this.$store.dispatch('settings/listVillages', { query: { city_id: newVal } })
      }
      this.onFilterChanged()
    },
    'filter.village_id': function () {
      this.onFilterChanged()
    },
    'filter.per_page': function (newVal) {
      // reset to first page when page size changes
      this.filter.page = 1
      this.fetchList()
    },
    'filter.landsurvey_review_status': function () {
      this.onFilterChanged()
    },
    'filter.landsurvey_survey_status': function () {
      this.onFilterChanged()
    },
    'filter.landsurvey_survey_date_from': function () {
      this.onFilterChanged()
    },
    'filter.landsurvey_survey_date_to': function () {
      this.onFilterChanged()
    },
  },
  data() {
    return {
      loadError: null,
      skeletonRowCount: 3,
      selectedStatus: null,
      selectedExecutionStatus: null,
      selectedProject: null,
      routePlanSelectionMode: 'all',
      selectedProjectIds: [],
      currentPage: 1,
      perPage: 30,
      totalRows: 0,
      checked: true,
      addNewUserModal: false,
      filter: {
        service_type_id: null,
        status: null,
        search: null,
        per_page: 15,
        page: 1,
        current_execution_status: null,
        custom_task_id: null,
        custom_task_status: null,
        owner_name: null,
        owner_national_id: null,
        owner_phone: null,
        owner_mobile: null,
        governorate_id: null,
        center_id: null,
        city_id: null,
        village_id: null,
        landsurvey_review_status: null,
        landsurvey_survey_status: null,
        landsurvey_survey_date_from: null,
        landsurvey_survey_date_to: null,
      },
      current_execution_status_data: [
        'مطلوب الاتصال',
        'مطلوب المعاينة',
        'مطلوب رسم الكاد',
        'مطلوب finish الكاد',
        'مطلوب ال sheep file',
        'مطلوب التدقيق QC',
        'مطلوب الرفع علي المنصة',
        'مطلوب تصحيح الخطأ علي المنصة',
        'تأكيد تم القبول علي المنصة',
        'تم الموافقة العسكرية',
        'مشكلة مساحة عسكرية',
        'تم تصفية الحساب',
        'لم يتم ارسال الملف من المنصة',
      ],
      customTaskStatusOptions: [
        { value: null, text: 'حالة المهمة المخصصة: الكل' },
        // { value: 'pending', text: 'قيد الانتظار' },
        { value: 'in_progress', text: 'جار' },
        { value: 'completed', text: 'تم' },
        // { value: 'review', text: 'قيد المراجعة' },
        { value: 'blocked', text: 'تعذر' },
        // { value: 'client_pending', text: 'في انتظار العميل' },
      ],
      status_data: [
        'planning', 'active', 'on_hold', 'completed', 'cancelled', 'deleted',
      ],
      landsurveyReviewStatusOptions: [
        'جاري الرفع',
        'لم يتم المعاينة',
        'تم اعادة المراجعة',
        'مرفوض',
        'مقبول',
      ],
      landsurveySurveyStatusOptions: [
        'تم الرفع المساحي',
        'لم يتم الرفع المساحي',
        'تعذر الرفع المساحى',
        'جاري الرفع المساحي',
      ],
      perPageOptions: [
        15,
        30,
        50,
        100,
        200,
        300,
      ],
      debouncedFilterChanged: null,
      customTaskOptions: [],
      loadingCustomTasks: false,
      routePlanExportLoading: false,
      routePlanExportFormat: null,
      dashboardGisTeamsExportLoading: false,
      dashboardGeodesiaTeamsExportLoading: false,
      bulkKmlExportLoading: false,
      bulkShapeExportLoading: false,
      showBulkKmlExportModal: false,
      showBulkShapeExportModal: false,
      bulkKmlHeaderNote: '',
      KML_HEADER_NOTE_MAX_LENGTH,
      shapeSchemasLoading: false,
      shapeSchemas: [],
      selectedShapeSchemaId: null,
      bulkShapeExportType: 'utm',
      bulkShapeTypeOptions: [
        { text: 'UTM', value: 'utm' },
        { text: 'Lat/Long', value: 'latLong' },
      ],
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    clearAllFilters() {
      // reset all filters but keep per_page default
      this.filter = {
        service_type_id: null,
        status: null,
        search: null,
        per_page: this.filter?.per_page || 15,
        page: 1,
        current_execution_status: null,
        custom_task_id: null,
        custom_task_status: null,
        owner_name: null,
        owner_national_id: null,
        owner_phone: null,
        owner_mobile: null,
        governorate_id: null,
        center_id: null,
        city_id: null,
        village_id: null,
        landsurvey_review_status: null,
        landsurvey_survey_status: null,
        landsurvey_survey_date_from: null,
        landsurvey_survey_date_to: null,
      }

      // Re-fetch base dropdown
      this.$store.dispatch('settings/listGovernorates', { query: {} })

      this.clearProjectSelection()
      this.fetchList()
    },
    cleanQuery(obj) {
      const q = {}
      Object.keys(obj || {}).forEach(k => {
        const v = obj[k]
        if (v === null || v === undefined) return
        if (typeof v === 'string' && v.trim() === '') return
        q[k] = v
      })
      // always keep per_page/page
      if (!q.per_page) q.per_page = this.filter.per_page || 15
      if (!q.page) q.page = this.filter.page || 1
      return q
    },
    onFilterChanged() {
      this.filter.page = 1
      this.clearProjectSelection()
      this.fetchList()
    },
    onRoutePlanSelectionModeChange() {
      // Route plan mode does not affect project selection used for bulk export.
    },
    isProjectSelected(projectId) {
      return this.selectedProjectIds.includes(projectId)
    },
    toggleProjectSelection(projectId, checked) {
      if (checked) {
        if (!this.selectedProjectIds.includes(projectId)) {
          this.selectedProjectIds = [...this.selectedProjectIds, projectId]
        }
      } else {
        this.selectedProjectIds = this.selectedProjectIds.filter(id => id !== projectId)
      }
    },
    toggleSelectAllOnPage(checked) {
      const pageIds = this.tableData.map(item => item.id)
      if (checked) {
        const merged = new Set([...this.selectedProjectIds, ...pageIds])
        this.selectedProjectIds = [...merged]
      } else {
        this.selectedProjectIds = this.selectedProjectIds.filter(id => !pageIds.includes(id))
      }
    },
    clearProjectSelection() {
      this.selectedProjectIds = []
    },
    async fetchList() {
      this.loadError = null
      const query = this.cleanQuery({ ...this.filter })
      try {
        await this.$store.dispatch('projects/listProjects', { query })
        // Fetch custom tasks from first project if available and options are empty
        if (this.customTaskOptions.length === 0 && this.tableData.length > 0) {
          this.fetchCustomTasksFromProject(this.tableData[0].id)
        }
      } catch (err) {
        const message = err?.response?.data?.message || err?.message || 'حدث خطأ أثناء تحميل المشاريع'
        this.loadError = message
      }
    },
    fetchCustomTasksFromProject(projectId) {
      if (!projectId || this.loadingCustomTasks) return

      this.loadingCustomTasks = true
      const projectsApi = new Projects()

      projectsApi.get168CustomTasks()
        .then(response => {
          const tasks = response.success && Array.isArray(response.data)
            ? response.data
            : Array.isArray(response.data)
              ? response.data
              : []

          // Extract unique custom task templates
          this.customTaskOptions = tasks
        })
        .catch(error => {
          console.error('Error fetching custom tasks:', error)
          // Silently fail - don't show error to user as this is optional
        })
        .finally(() => {
          this.loadingCustomTasks = false
        })
    },
    retryLoad() {
      this.loadError = null
      this.fetchList()
    },
    openUpdateProjectStatusModal(project) {
      this.selectedProject = project
      this.$bvModal.show('update-project-status-modal')
    },
    updateProjectStatus() {
      this.$store.dispatch('projects/updateProjectStatus', { id: this.selectedProject.id, query: { status: this.selectedStatus } }).then(res => {
        this.$bvModal.hide('update-project-status-modal')
        this.refreshData()
      }).catch(err => {
        this.$swal('خطأ!', err?.response?.data?.message || 'حدث خطأ أثناء تحديث حالة المشروع', 'error')
      })
    },
    deleteProject(project) {
      this.$swal({
        title: 'هل أنت متأكد؟',
        text: 'سيتم حذف المشروع بشكل نهائي!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'نعم، احذف!',
        cancelButtonText: 'إلغاء',
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch('projects/delete', { id: project.id }).then(res => {
            this.$swal('تم الحذف!', 'تم حذف المشروع.', 'success')
            this.refreshData()
          }).catch(err => {
            this.$swal('خطأ!', err?.response?.data?.message || 'حدث خطأ أثناء الحذف', 'error')
          })
        }
      })
    },
    restoreProject(project) {
      this.$swal({
        title: 'هل أنت متأكد؟',
        text: 'سيتم استعادة المشروع!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'نعم، استعادة!',
        cancelButtonText: 'إلغاء',
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch('projects/restore', { id: project.id }).then(res => {
            this.$swal('تم الاستعادة!', 'تم استعادة المشروع.', 'success')
            this.refreshData()
          }).catch(err => {
            this.$swal('خطأ!', err?.response?.data?.message || 'حدث خطأ أثناء الاستعادة', 'error')
          })
        }
      })
    },
    hardDeleteProject(project) {
      this.$swal({
        title: 'هل أنت متأكد؟',
        text: 'سيتم حذف المشروع بشكل نهائي!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#d33',
        cancelButtonColor: '#3085d6',
        confirmButtonText: 'نعم، احذف!',
        cancelButtonText: 'إلغاء',
      }).then(result => {
        if (result.isConfirmed) {
          this.$store.dispatch('projects/hardDelete', { id: project.id }).then(res => {
            this.$swal('تم الحذف!', 'تم حذف المشروع.', 'success')
            this.refreshData()
          }).catch(err => {
            this.$swal('خطأ!', err?.response?.data?.message || 'حدث خطأ أثناء الحذف', 'error')
          })
        }
      })
    },
    openCoordinatesMap(project) {
      this.$router.push({ name: 'project_coordinates_map', params: { id: project.id } })
    },
    openUpdateExecutionStatusModal(project) {
      this.selectedProject = project
      this.selectedExecutionStatus = project.current_execution_status || null
      this.$bvModal.show('update-execution-status-modal')
    },
    updateExecutionStatus() {
      if (!this.selectedProject || !this.selectedExecutionStatus) return
      this.$store
        .dispatch('projects/updateCurrentExecutionStatus', {
          id: this.selectedProject.id,
          current_execution_status: this.selectedExecutionStatus,
        })
        .then(() => {
          this.$bvModal.hide('update-execution-status-modal')
          this.refreshData()
        })
        .catch(err => {
          const status = err?.response?.status
          const message = err?.response?.data?.message
            || err?.response?.data?.errors?.current_execution_status?.[0]
            || err?.message
            || 'حدث خطأ أثناء تحديث الحالة التنفيذية'
          if (status === 403) {
            this.$swal('صلاحيات', 'لا تملك صلاحية تعديل المشاريع', 'error')
          } else {
            this.$swal('خطأ', message, 'error')
          }
        })
    },
    gotoProjectsMap() {
      this.$router.push({ name: 'projects_map' })
    },
    gotoAddPro() {
      this.$router.push({ name: 'add_project' })
    },
    importOrderSurvey() {
      this.$router.push({ name: 'landsurvey-orders-import' })
    },
    gotoAddPro_168() {
      this.$router.push({ name: 'add_project', params: { type: 168 } })
    },
    gotoSeizureInventory() {
      this.$router.push({ name: 'seizure-land-inventories-create' })
    },
    gotoMultiProjectsKMLImport() {
      this.$router.push({ name: 'multi-projects-kml-import' })
    },
    onPageChange(page) {
      this.filter.page = page
      this.fetchList()
    },
    refreshData() {
      this.filter.page = this.items?.meta?.current_page || this.filter.page || 1
      this.fetchList()
    },
    getCurrentRowsRange() {
      if (!this.items || !this.items.meta) return '0-0'
      const { meta } = this.items
      const currentPage = meta.current_page || 1
      const perPage = meta.per_page || this.perPage
      const total = meta.total || 0

      const from = total === 0 ? 0 : ((currentPage - 1) * perPage) + 1
      const to = Math.min(currentPage * perPage, total)

      return `${from}-${to}`
    },
    joinRoles(roles) {
      return roles.join(', ')
    },
    copySurveyingCode(surveyingCode) {
      if (!surveyingCode) return
      this.$copyText(surveyingCode).then(() => {
        this.$toast.success('تم نسخ الكود المساحي بنجاح')
      }).catch(() => {
        this.$toast.error('فشل نسخ الكود المساحي')
      })
    },
    goToProjectDetails(project) {
      if (project && project.id) {
        this.$router.push({
          name: 'project_details',
          params: { id: project.id },
        })
      }
    },
    formatPhoneForWhatsApp(phone) {
      if (!phone) return ''
      // Remove all non-numeric characters
      let cleaned = phone.replace(/[^0-9]/g, '')
      // If starts with 0, replace with 20 (Egypt country code)
      if (cleaned.startsWith('0')) {
        cleaned = `20${cleaned.substring(1)}`
      }
      // If doesn't start with 20, add it
      if (!cleaned.startsWith('20')) {
        cleaned = `20${cleaned}`
      }
      return cleaned
    },
    openProjectModal() {

    },
    init() {
      this.debouncedFilterChanged = this.debounce(() => this.onFilterChanged(), 400)
      this.$store.dispatch('settings/listGovernorates', { query: { is_active: 1 } })
      this.fetchList()
      this.$store.dispatch('serviceTypes/fetchServiceTypes')
    },
    debounce(fn, wait) {
      let t
      return (...args) => {
        clearTimeout(t)
        t = setTimeout(() => fn.apply(this, args), wait)
      }
    },

    exportProjects() {

    },

    async getRoutePlanFilters() {
      const payload = this.cleanQuery({ ...this.filter })
      delete payload.per_page
      delete payload.page

      if (this.routePlanSelectionMode === 'custom' && this.selectedProjectIds.length) {
        payload.project_ids = [...this.selectedProjectIds]
      }

      try {
        const pos = await new Promise((resolve, reject) => {
          if (!navigator.geolocation) return reject(new Error('no_geolocation'))
          navigator.geolocation.getCurrentPosition(resolve, reject, { timeout: 6000 })
        })
        payload.starting_lat = pos.coords.latitude
        payload.starting_lng = pos.coords.longitude
      } catch (_) {
        // starting coordinates are optional
      }

      return payload
    },

    async parseRoutePlanExportError(data) {
      if (data instanceof Blob) {
        const text = await data.text()
        try {
          return JSON.parse(text)
        } catch (e) {
          return { message: text }
        }
      }
      return data || {}
    },

    triggerRoutePlanBlobDownload(blob, filename) {
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },

    async exportRoutePlan(format) {
      if (this.routePlanExportLoading) return

      if (this.routePlanSelectionMode === 'custom' && !this.selectedProjectIds.length) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'يرجى اختيار مشروع واحد على الأقل',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
        return
      }

      if (format === 'pdf') {
        const total = this.routePlanSelectionMode === 'custom'
          ? this.selectedProjectIds.length
          : this.filteredProjectsTotal
        if (total > 500) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'ملاحظة: يعرض PDF أول 500 مشروع فقط، استخدم Excel للقائمة الكاملة',
              icon: 'InfoIcon',
              variant: 'warning',
            },
          })
        }
      }

      this.routePlanExportLoading = true
      this.routePlanExportFormat = format

      try {
        const filters = await this.getRoutePlanFilters()
        const projectsApi = new Projects()
        const response = await projectsApi.exportRoutePlan({ ...filters, format })

        if (response.status === 404 || response.status === 422) {
          const payload = await this.parseRoutePlanExportError(response.data)
          this.$toast.error(payload.message || 'فشل التصدير')
          return
        }

        let { data: blob } = response
        const contentType = String(response.headers['content-type'] || '').toLowerCase()

        if (contentType.includes('application/json')) {
          const payload = await this.parseRoutePlanExportError(blob)
          this.$toast.error(payload.message || 'فشل التصدير')
          return
        }

        if (!(blob instanceof Blob)) {
          blob = new Blob([blob])
        }

        const ext = format === 'pdf' ? 'pdf' : 'xlsx'
        const filename = `خط-السير-${new Date().toISOString().slice(0, 10)}.${ext}`
        this.triggerRoutePlanBlobDownload(blob, filename)
        this.$toast.success('تم تنزيل الملف بنجاح')
      } catch (err) {
        let message = err?.response?.data?.message || err?.message || 'حدث خطأ أثناء التصدير'
        if (err?.response?.data) {
          const payload = await this.parseRoutePlanExportError(err.response.data)
          message = payload.message || message
        }
        this.$toast.error(message)
      } finally {
        this.routePlanExportLoading = false
        this.routePlanExportFormat = null
      }
    },

    dashboardTeamsExportFilename(kind, contentDisposition) {
      const header = String(contentDisposition || '')
      const utfMatch = /filename\*=UTF-8''([^;]+)/i.exec(header)
      if (utfMatch && utfMatch[1]) {
        try {
          return decodeURIComponent(utfMatch[1].replace(/"/g, '').trim())
        } catch (e) {
          // fall through
        }
      }
      const plainMatch = /filename="?([^";]+)"?/i.exec(header)
      if (plainMatch && plainMatch[1]) {
        return plainMatch[1].trim()
      }
      const now = new Date()
      const pad = value => String(value).padStart(2, '0')
      const stamp = `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}_${pad(now.getHours())}${pad(now.getMinutes())}${pad(now.getSeconds())}`
      return `dashboard_${kind}_teams_${stamp}.xlsx`
    },

    dashboardTeamsExportEmptyMessage(kind, code) {
      const messages = {
        no_dashboard_gis_team_projects_to_export: 'لا توجد مشاريع لتصدير فرق GIS',
        no_dashboard_geodesia_team_projects_to_export: 'لا توجد مشاريع لتصدير فرق الجيوديسيا',
      }
      if (code && messages[code]) return messages[code]
      if (kind === 'geodesia') return messages.no_dashboard_geodesia_team_projects_to_export
      return messages.no_dashboard_gis_team_projects_to_export
    },

    exportDashboardGisTeams() {
      return this.exportDashboardTeams('gis')
    },

    exportDashboardGeodesiaTeams() {
      return this.exportDashboardTeams('geodesia')
    },

    async exportDashboardTeams(kind) {
      const loadingKey = kind === 'geodesia'
        ? 'dashboardGeodesiaTeamsExportLoading'
        : 'dashboardGisTeamsExportLoading'
      if (this[loadingKey]) return

      this[loadingKey] = true
      try {
        const projectsApi = new Projects()
        const response = kind === 'geodesia'
          ? await projectsApi.exportDashboardGeodesiaTeams()
          : await projectsApi.exportDashboardGisTeams()

        if (response.status === 404 || response.status === 422) {
          const payload = await this.parseRoutePlanExportError(response.data)
          const code = payload.message || payload.code
          this.$toast.error(this.dashboardTeamsExportEmptyMessage(kind, code))
          return
        }

        let { data: blob } = response
        const contentType = String(response.headers['content-type'] || '').toLowerCase()

        if (contentType.includes('application/json')) {
          const payload = await this.parseRoutePlanExportError(blob)
          this.$toast.error(this.dashboardTeamsExportEmptyMessage(kind, payload.message || payload.code))
          return
        }

        if (!(blob instanceof Blob)) {
          blob = new Blob([blob])
        }

        const filename = this.dashboardTeamsExportFilename(
          kind,
          response.headers['content-disposition'] || response.headers['Content-Disposition'],
        )
        this.triggerRoutePlanBlobDownload(blob, filename)
        this.$toast.success('تم تنزيل الملف بنجاح')
      } catch (err) {
        let payload = {}
        if (err?.response?.data) {
          payload = await this.parseRoutePlanExportError(err.response.data)
        }
        const status = err?.response?.status
        const code = payload.message || payload.code
        if (status === 404 || status === 422) {
          this.$toast.error(this.dashboardTeamsExportEmptyMessage(kind, code))
        } else {
          this.$toast.error(payload.message || err?.message || 'حدث خطأ أثناء التصدير')
        }
      } finally {
        this[loadingKey] = false
      }
    },

    getSelectedProjectIdsForExport() {
      return this.selectedProjectIds
        .map(id => Number(id))
        .filter(id => Number.isFinite(id) && id > 0)
    },

    ensureBulkExportSelection() {
      const projectIds = this.getSelectedProjectIdsForExport()
      if (!projectIds.length) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'يرجى اختيار مشروع واحد على الأقل / Please select at least one project',
            icon: 'AlertCircleIcon',
            variant: 'warning',
          },
        })
        return null
      }
      return projectIds
    },

    loadBulkKmlHeaderNoteFromStorage() {
      try {
        const stored = window.localStorage.getItem(KML_HEADER_NOTE_STORAGE_KEY)
        this.bulkKmlHeaderNote = stored || ''
      } catch (e) {
        this.bulkKmlHeaderNote = ''
      }
    },

    saveBulkKmlHeaderNoteToStorage() {
      try {
        window.localStorage.setItem(KML_HEADER_NOTE_STORAGE_KEY, this.bulkKmlHeaderNote || '')
      } catch (e) {
        // ignore quota errors
      }
    },

    getEffectiveBulkKmlHeaderNote() {
      const trimmed = String(this.bulkKmlHeaderNote || '').trim()
      return trimmed || undefined
    },

    openBulkKmlExportModal() {
      if (this.bulkKmlExportLoading || !this.ensureBulkExportSelection()) return
      this.loadBulkKmlHeaderNoteFromStorage()
      this.showBulkKmlExportModal = true
    },

    openBulkShapeExportModal() {
      if (this.bulkShapeExportLoading || !this.ensureBulkExportSelection()) return
      this.selectedShapeSchemaId = null
      this.bulkShapeExportType = 'utm'
      this.showBulkShapeExportModal = true
    },

    async loadShapeSchemasForExport() {
      this.shapeSchemasLoading = true
      try {
        const response = await projectShapeSchemasApi.list()
        this.shapeSchemas = Array.isArray(response.data) ? response.data : (Array.isArray(response) ? response : [])
      } catch (e) {
        this.shapeSchemas = []
      } finally {
        this.shapeSchemasLoading = false
      }
    },

    parseDownloadFilename(contentDisposition, fallbackName) {
      if (!contentDisposition || typeof contentDisposition !== 'string') return fallbackName

      const utf8Match = contentDisposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i)
      if (utf8Match && utf8Match[1]) {
        try {
          return decodeURIComponent(utf8Match[1]).replace(/["']/g, '')
        } catch (e) {
          return utf8Match[1].replace(/["']/g, '')
        }
      }

      const simpleMatch = contentDisposition.match(/filename\s*=\s*"?([^";]+)"?/i)
      if (simpleMatch && simpleMatch[1]) {
        return simpleMatch[1].trim()
      }

      return fallbackName
    },

    bulkKmlExportErrorMessage(payload, status) {
      if (status === 403) {
        return 'لا تملك صلاحية الوصول لأحد المشاريع المحددة / Branch access denied for one or more selected projects.'
      }

      const key = payload?.message
      const detail = typeof payload?.errors === 'string'
        ? payload.errors
        : (payload?.errors && typeof payload?.errors === 'object'
          ? Object.values(payload.errors).flat().filter(Boolean).join(' ')
          : '')
      const map = {
        no_projects_found: 'لم يتم العثور على المشاريع المحددة / No matching projects found.',
        no_coordinates_for_kml_export: 'لا توجد إحداثيات متاحة لتصدير KML / No selected project had valid KML coordinates.',
      }
      if (key && map[key]) return map[key]

      if (status === 404) {
        return map.no_projects_found
      }
      if (status === 422) {
        const note = String(this.bulkKmlHeaderNote || '').trim()
        if (note.length > KML_HEADER_NOTE_MAX_LENGTH) {
          return 'نص ملاحظة رأس التقرير يتجاوز الحد المسموح (2000 حرف) / Header note exceeds maximum length (2000 characters).'
        }
      }
      if (status >= 500) {
        return 'حدث خطأ في الخادم أثناء تصدير KML / Server error while exporting KML.'
      }

      if (detail) return detail
      if (typeof key === 'string' && key.trim()) return key.trim()
      return 'تعذر تنزيل ملف KML / Unable to download KML.'
    },

    bulkShapeExportErrorMessage(payload, status) {
      if (status === 403) {
        return 'لا تملك صلاحية الوصول لأحد المشاريع المحددة / Branch access denied for one or more selected projects.'
      }
      if (status === 404) {
        return 'لم يتم العثور على المشاريع المحددة / No matching projects found.'
      }

      const key = payload?.message
      const detail = typeof payload?.errors === 'string'
        ? payload.errors
        : (payload?.errors && typeof payload?.errors === 'object'
          ? Object.values(payload.errors).flat().filter(Boolean).join(' ')
          : '')
      const map = {
        no_projects_found: 'لم يتم العثور على المشاريع المحددة / No matching projects found.',
        no_coordinates_for_shape_export: 'لا توجد إحداثيات متاحة لتصدير ملف Shape ZIP / No selected project had exportable coordinates.',
        project_shape_schema_invalid: 'مخطط Shape غير صالح / Invalid schema.',
        failed_to_create_zip: detail || 'فشل إنشاء ملف ZIP / Failed to create ZIP.',
        shape_export_failed: detail || 'فشل إنشاء ملف Shape ZIP / Shape generation error.',
      }
      if (key && map[key]) return map[key]
      if (status >= 500) {
        return detail || 'حدث خطأ في الخادم أثناء تصدير Shapefile / Server error while exporting shapefile.'
      }
      if (detail) return detail
      if (typeof key === 'string' && key.length) return key
      return 'تعذر تنزيل ملف Shape ZIP / Unable to download shapefile.'
    },

    async handleBulkBlobExportResponse(response, {
      fallbackFilename,
      defaultBlobType = 'application/octet-stream',
      errorMessageFn,
    }) {
      const status = Number(response?.status || 0)
      let { data: blob } = response

      if (status >= 400) {
        const payload = await this.parseRoutePlanExportError(blob)
        throw new Error(errorMessageFn(payload, status))
      }

      const contentType = String(response.headers['content-type'] || '').toLowerCase()
      if (contentType.includes('application/json')) {
        const payload = await this.parseRoutePlanExportError(blob)
        throw new Error(errorMessageFn(payload, status))
      }

      if (!(blob instanceof Blob)) {
        blob = new Blob([blob], { type: defaultBlobType })
      }

      const contentDisposition = response.headers['content-disposition']
        || response.headers['Content-Disposition']
        || ''
      const filename = this.parseDownloadFilename(contentDisposition, fallbackFilename)
      this.triggerRoutePlanBlobDownload(blob, filename)
    },

    async confirmBulkKmlExport(event) {
      if (event?.preventDefault) event.preventDefault()

      const projectIds = this.ensureBulkExportSelection()
      if (!projectIds || this.bulkKmlExportLoading) return

      const headerNote = this.getEffectiveBulkKmlHeaderNote()
      if (headerNote && headerNote.length > KML_HEADER_NOTE_MAX_LENGTH) {
        this.$toast.error('نص ملاحظة رأس التقرير يتجاوز الحد المسموح (2000 حرف) / Header note exceeds maximum length (2000 characters).')
        return
      }

      this.saveBulkKmlHeaderNoteToStorage()
      this.bulkKmlExportLoading = true

      try {
        const projectsApi = new Projects()
        const response = await projectsApi.exportSelectedProjectsKml(projectIds, { headerNote })
        await this.handleBulkBlobExportResponse(response, {
          fallbackFilename: 'selected_projects.kml',
          defaultBlobType: 'application/vnd.google-earth.kml+xml',
          errorMessageFn: (payload, status) => this.bulkKmlExportErrorMessage(payload, status),
        })
        this.showBulkKmlExportModal = false
        this.$toast.success('تم تنزيل ملف KML بنجاح / KML file downloaded successfully')
      } catch (err) {
        let message = err?.message || 'حدث خطأ أثناء تصدير KML / Error exporting KML'
        if (err?.response?.data) {
          const payload = await this.parseRoutePlanExportError(err.response.data)
          message = this.bulkKmlExportErrorMessage(payload, err.response.status)
        }
        this.$toast.error(message)
      } finally {
        this.bulkKmlExportLoading = false
      }
    },

    async confirmBulkShapeExport(event) {
      if (event?.preventDefault) event.preventDefault()

      const projectIds = this.ensureBulkExportSelection()
      if (!projectIds || this.bulkShapeExportLoading) return

      if (!this.selectedShapeSchemaId) {
        this.$toast.error('يرجى اختيار Schema / Please select a schema')
        return
      }

      this.bulkShapeExportLoading = true

      try {
        const projectsApi = new Projects()
        const response = await projectsApi.exportSelectedProjectsShapefile(
          projectIds,
          this.selectedShapeSchemaId,
          this.bulkShapeExportType || 'utm',
        )
        await this.handleBulkBlobExportResponse(response, {
          fallbackFilename: 'selected_projects_shapefile.zip',
          defaultBlobType: 'application/zip',
          errorMessageFn: (payload, status) => this.bulkShapeExportErrorMessage(payload, status),
        })
        this.showBulkShapeExportModal = false
        this.$toast.success('تم تنزيل ملف Shapefile بنجاح / Shapefile ZIP downloaded successfully')
      } catch (err) {
        let message = err?.message || 'حدث خطأ أثناء تصدير Shapefile / Error exporting shapefile'
        if (err?.response?.data) {
          const payload = await this.parseRoutePlanExportError(err.response.data)
          message = this.bulkShapeExportErrorMessage(payload, err.response.status)
        }
        this.$toast.error(message)
      } finally {
        this.bulkShapeExportLoading = false
      }
    },

  },
}
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/pages/dashboard-ecommerce.scss";
@import "@core/scss/vue/libs/chart-apex.scss";
@import '@core/scss/vue/libs/vue-flatpicker.scss';

/* Skeleton loading: show table structure while data loads */
.projects-table-skeleton {
  min-height: 280px;
}
.survey-filter{
  background-color: #d5f3f7;
  // padding: 10px;
}
.location-filter{
  background-color: rgb(39, 62, 66);
//padding: 10px;
}

.location-filter ::v-deep .vs__search,
.location-filter ::v-deep .vs__search:focus {
  color: #fff;
}

.location-filter ::v-deep .vs__selected {
  color: #fff;
}

.location-filter ::v-deep input::placeholder {
  color: rgba(255, 255, 255, 0.7);
}

.location-filter ::v-deep .vs__dropdown-toggle {
  color: #fff;
}
.surveying-code-cell {
  display: inline-block;
  padding: 2px 6px;
  border-radius: 4px;
}
.surveying-code-red {
  background-color: #ff4d4f;
  color: #fff !important;
}
.surveying-code-red:hover {
  color: #fff !important;
  opacity: 0.9;
}
.skeleton-table {
  pointer-events: none;
  user-select: none;
}

.skeleton-bar {
  height: 14px;
  border-radius: 4px;
  background: linear-gradient(
    90deg,
    #e9ecef 25%,
    #f8f9fa 50%,
    #e9ecef 75%
  );
  background-size: 200% 100%;
  animation: skeleton-wave 1.5s ease-in-out infinite;
}

.skeleton-actions {
  max-width: 80px;
}

@keyframes skeleton-wave {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

/* Dark layout skeleton */
::v-deep .dark-layout .skeleton-bar {
  background: linear-gradient(
    90deg,
    #3b4253 25%,
    #4a5568 50%,
    #3b4253 75%
  );
  background-size: 200% 100%;
}

.projects-toolbar-actions {
  min-width: 0;
  max-width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
}

.projects-toolbar-actions__scroller {
  width: 100%;
  min-width: min-content;
}

/* Mobile Card View Styles */
.project-card-mobile {

  .b-card {
    background-color: #c5f6e6 !important;
    border-radius: 8px;
    border: 1px solid #d0e7ff;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  }

  .project-info-item {
    small {
      font-size: 0.75rem;
      font-weight: 600;
    }
    div {
      font-size: 0.875rem;
      word-break: break-word;
    }
  }

  .info-badge {
    display: inline-flex;
    align-items: center;
    background-color: #e3f2fd;
    color: #1976d2;
    padding: 4px 8px;
    border-radius: 6px;
    font-size: 0.8rem;
    font-weight: 500;
    margin-bottom: 4px;

    .feather-icon {
      color: #1976d2;
    }
  }

  .gap-2 {
    gap: 0.5rem;
  }

  .project-card-actions {
    ::v-deep .feather-icon,
    ::v-deep a {
      cursor: pointer;
      transition: opacity 0.2s;

      &:hover {
        opacity: 0.7;
      }
    }
  }
}

/* Mobile Responsive Styles */
@media (max-width: 767.98px) {
  .filter-card {
    .b-row {
      margin: 0;
    }

    .b-col {
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      margin-bottom: 0.5rem;
    }
  }

  ::v-deep .b-table {
    font-size: 0.8rem;

    th, td {
      padding: 0.5rem 0.25rem;
      font-size: 0.8rem;
    }
  }

  .project-card-mobile {
    .project-card-header h6 {
      font-size: 0.95rem;
    }
  }

  ::v-deep .project-modal {
    .modal-dialog {
      margin: 0.5rem;
      max-width: calc(100% - 1rem);
    }
  }

  .gap-2 {
    gap: 0.5rem !important;
  }
}

/* Extra Small Devices */
@media (max-width: 575.98px) {
  .project-card-mobile {
    .project-card-header h6 {
      font-size: 0.9rem;
    }

    .project-info-item {
      small {
        font-size: 0.7rem;
      }
      div {
        font-size: 0.8rem;
      }
    }
  }
}

/* Ensure proper scrolling on mobile */
@media (max-width: 767.98px) {
  ::v-deep .table-responsive {
    -webkit-overflow-scrolling: touch;
  }

  .projects-toolbar-actions {
    padding-bottom: 0.25rem;
  }

  .projects-action-btn {
    padding: 0.5rem;
    line-height: 0.5;

    &__icon {
      margin: 0 !important;
    }
  }
}

@media (min-width: 768px) {
  .projects-action-btn__icon {
    margin-right: 0.5rem;
  }
}
</style>
